module.exports = __webpack_public_path__ + "static/media/CarAccident.710f4311.svg";